function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.reactTextMask = t(require("react")) : e.reactTextMask = t(e.React);
}(this, function (e) {
  return function (e) {
    function t(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        exports: {},
        id: n,
        loaded: !1
      };
      return e[n].call(o.exports, o, o.exports, t), o.loaded = !0, o.exports;
    }

    var r = {};
    return t.m = e, t.c = r, t.p = "", t(0);
  }([function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function o(e, t) {
      var r = {};

      for (var n in e) {
        t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
      }

      return r;
    }

    function i(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function a(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    function u(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.conformToMask = void 0;

    var s = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    },
        l = function () {
      function e(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      return function (t, r, n) {
        return r && e(t.prototype, r), n && e(t, n), t;
      };
    }(),
        f = r(3);

    Object.defineProperty(t, "conformToMask", {
      enumerable: !0,
      get: function get() {
        return n(f).default;
      }
    });

    var c = r(11),
        p = n(c),
        d = r(9),
        h = n(d),
        v = r(5),
        y = n(v),
        m = r(2),
        b = function (e) {
      function t() {
        var e;
        i(this, t);

        for (var r = arguments.length, n = Array(r), o = 0; o < r; o++) {
          n[o] = arguments[o];
        }

        var u = a(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(n)));
        return u.setRef = u.setRef.bind(u), u.onBlur = u.onBlur.bind(u), u.onChange = u.onChange.bind(u), u;
      }

      return u(t, e), l(t, [{
        key: "setRef",
        value: function value(e) {
          this.inputElement = e;
        }
      }, {
        key: "initTextMask",
        value: function value() {
          var e = this.props,
              t = this.props.value;
          this.textMaskInputElement = (0, y.default)(s({
            inputElement: this.inputElement
          }, e)), this.textMaskInputElement.update(t);
        }
      }, {
        key: "componentDidMount",
        value: function value() {
          this.initTextMask();
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e) {
          var t = this.props,
              r = t.value,
              n = t.pipe,
              o = t.mask,
              i = t.guide,
              a = t.placeholderChar,
              u = t.showMask,
              s = {
            guide: i,
            placeholderChar: a,
            showMask: u
          },
              l = "function" == typeof n && "function" == typeof e.pipe ? n.toString() !== e.pipe.toString() : (0, m.isNil)(n) && !(0, m.isNil)(e.pipe) || !(0, m.isNil)(n) && (0, m.isNil)(e.pipe),
              f = o.toString() !== e.mask.toString(),
              c = Object.keys(s).some(function (t) {
            return s[t] !== e[t];
          }) || f || l,
              p = r !== this.inputElement.value;
          (p || c) && this.initTextMask();
        }
      }, {
        key: "render",
        value: function e() {
          var t = this.props,
              e = t.render,
              r = o(t, ["render"]);
          return delete r.mask, delete r.guide, delete r.pipe, delete r.placeholderChar, delete r.keepCharPositions, delete r.value, delete r.onBlur, delete r.onChange, delete r.showMask, e(this.setRef, s({
            onBlur: this.onBlur,
            onChange: this.onChange,
            defaultValue: this.props.value
          }, r));
        }
      }, {
        key: "onChange",
        value: function value(e) {
          this.textMaskInputElement.update(), "function" == typeof this.props.onChange && this.props.onChange(e);
        }
      }, {
        key: "onBlur",
        value: function value(e) {
          "function" == typeof this.props.onBlur && this.props.onBlur(e);
        }
      }]), t;
    }(p.default.PureComponent);

    t.default = b, b.propTypes = {
      mask: h.default.oneOfType([h.default.array, h.default.func, h.default.bool, h.default.shape({
        mask: h.default.oneOfType([h.default.array, h.default.func]),
        pipe: h.default.func
      })]).isRequired,
      guide: h.default.bool,
      value: h.default.oneOfType([h.default.string, h.default.number]),
      pipe: h.default.func,
      placeholderChar: h.default.string,
      keepCharPositions: h.default.bool,
      showMask: h.default.bool
    }, b.defaultProps = {
      render: function render(e, t) {
        return p.default.createElement("input", s({
          ref: e
        }, t));
      }
    };
  }, function (e, t) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.placeholderChar = "_", t.strFunction = "function";
  }, function (e, t, r) {
    "use strict";

    function n() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : f,
          t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l.placeholderChar;
      if (!o(e)) throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");
      if (e.indexOf(t) !== -1) throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n" + ("The placeholder character that was received is: " + JSON.stringify(t) + "\n\n") + ("The mask that was received is: " + JSON.stringify(e)));
      return e.map(function (e) {
        return e instanceof RegExp ? t : e;
      }).join("");
    }

    function o(e) {
      return Array.isArray && Array.isArray(e) || e instanceof Array;
    }

    function i(e) {
      return "string" == typeof e || e instanceof String;
    }

    function a(e) {
      return "number" == typeof e && void 0 === e.length && !isNaN(e);
    }

    function u(e) {
      return "undefined" == typeof e || null === e;
    }

    function s(e) {
      for (var t = [], r = void 0; r = e.indexOf(c), r !== -1;) {
        t.push(r), e.splice(r, 1);
      }

      return {
        maskWithoutCaretTraps: e,
        indexes: t
      };
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.convertMaskToPlaceholder = n, t.isArray = o, t.isString = i, t.isNumber = a, t.isNil = u, t.processCaretTraps = s;
    var l = r(1),
        f = [],
        c = "[]";
  }, function (e, t, r) {
    "use strict";

    function n() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : s,
          t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : u,
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};

      if (!(0, i.isArray)(t)) {
        if (("undefined" == typeof t ? "undefined" : o(t)) !== a.strFunction) throw new Error("Text-mask:conformToMask; The mask property must be an array.");
        t = t(e, r), t = (0, i.processCaretTraps)(t).maskWithoutCaretTraps;
      }

      var n = r.guide,
          l = void 0 === n || n,
          f = r.previousConformedValue,
          c = void 0 === f ? s : f,
          p = r.placeholderChar,
          d = void 0 === p ? a.placeholderChar : p,
          h = r.placeholder,
          v = void 0 === h ? (0, i.convertMaskToPlaceholder)(t, d) : h,
          y = r.currentCaretPosition,
          m = r.keepCharPositions,
          b = l === !1 && void 0 !== c,
          g = e.length,
          k = c.length,
          C = v.length,
          O = t.length,
          T = g - k,
          P = T > 0,
          x = y + (P ? -T : 0),
          w = x + Math.abs(T);

      if (m === !0 && !P) {
        for (var S = s, _ = x; _ < w; _++) {
          v[_] === d && (S += d);
        }

        e = e.slice(0, x) + S + e.slice(x, g);
      }

      for (var M = e.split(s).map(function (e, t) {
        return {
          char: e,
          isNew: t >= x && t < w
        };
      }), j = g - 1; j >= 0; j--) {
        var E = M[j].char;

        if (E !== d) {
          var R = j >= x && k === O;
          E === v[R ? j - T : j] && M.splice(j, 1);
        }
      }

      var V = s,
          N = !1;

      e: for (var A = 0; A < C; A++) {
        var B = v[A];

        if (B === d) {
          if (M.length > 0) for (; M.length > 0;) {
            var I = M.shift(),
                F = I.char,
                q = I.isNew;

            if (F === d && b !== !0) {
              V += d;
              continue e;
            }

            if (t[A].test(F)) {
              if (m === !0 && q !== !1 && c !== s && l !== !1 && P) {
                for (var D = M.length, L = null, W = 0; W < D; W++) {
                  var J = M[W];
                  if (J.char !== d && J.isNew === !1) break;

                  if (J.char === d) {
                    L = W;
                    break;
                  }
                }

                null !== L ? (V += F, M.splice(L, 1)) : A--;
              } else V += F;

              continue e;
            }

            N = !0;
          }
          b === !1 && (V += v.substr(A, C));
          break;
        }

        V += B;
      }

      if (b && P === !1) {
        for (var U = null, H = 0; H < V.length; H++) {
          v[H] === d && (U = H);
        }

        V = null !== U ? V.substr(0, U + 1) : s;
      }

      return {
        conformedValue: V,
        meta: {
          someCharsRejected: N
        }
      };
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    };
    t.default = n;
    var i = r(2),
        a = r(1),
        u = [],
        s = "";
  }, function (e, t) {
    "use strict";

    function r(e) {
      var t = e.previousConformedValue,
          r = void 0 === t ? o : t,
          i = e.previousPlaceholder,
          a = void 0 === i ? o : i,
          u = e.currentCaretPosition,
          s = void 0 === u ? 0 : u,
          l = e.conformedValue,
          f = e.rawValue,
          c = e.placeholderChar,
          p = e.placeholder,
          d = e.indexesOfPipedChars,
          h = void 0 === d ? n : d,
          v = e.caretTrapIndexes,
          y = void 0 === v ? n : v;
      if (0 === s || !f.length) return 0;
      var m = f.length,
          b = r.length,
          g = p.length,
          k = l.length,
          C = m - b,
          O = C > 0,
          T = 0 === b,
          P = C > 1 && !O && !T;
      if (P) return s;

      var x = O && (r === l || l === p),
          w = 0,
          S = void 0,
          _ = void 0;

      if (x) w = s - C;else {
        var M = l.toLowerCase(),
            j = f.toLowerCase(),
            E = j.substr(0, s).split(o),
            R = E.filter(function (e) {
          return M.indexOf(e) !== -1;
        });
        _ = R[R.length - 1];
        var V = a.substr(0, R.length).split(o).filter(function (e) {
          return e !== c;
        }).length,
            N = p.substr(0, R.length).split(o).filter(function (e) {
          return e !== c;
        }).length,
            A = N !== V,
            B = void 0 !== a[R.length - 1] && void 0 !== p[R.length - 2] && a[R.length - 1] !== c && a[R.length - 1] !== p[R.length - 1] && a[R.length - 1] === p[R.length - 2];
        !O && (A || B) && V > 0 && p.indexOf(_) > -1 && void 0 !== f[s] && (S = !0, _ = f[s]);

        for (var I = h.map(function (e) {
          return M[e];
        }), F = I.filter(function (e) {
          return e === _;
        }).length, q = R.filter(function (e) {
          return e === _;
        }).length, D = p.substr(0, p.indexOf(c)).split(o).filter(function (e, t) {
          return e === _ && f[t] !== e;
        }).length, L = D + q + F + (S ? 1 : 0), W = 0, J = 0; J < k; J++) {
          var U = M[J];
          if (w = J + 1, U === _ && W++, W >= L) break;
        }
      }

      if (O) {
        for (var H = w, Y = w; Y <= g; Y++) {
          if (p[Y] === c && (H = Y), p[Y] === c || y.indexOf(Y) !== -1 || Y === g) return H;
        }
      } else if (S) {
        for (var z = w - 1; z >= 0; z--) {
          if (l[z] === _ || y.indexOf(z) !== -1 || 0 === z) return z;
        }
      } else for (var G = w; G >= 0; G--) {
        if (p[G - 1] === c || y.indexOf(G) !== -1 || 0 === G) return G;
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    var n = [],
        o = "";
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function o(e) {
      var t = {
        previousConformedValue: void 0,
        previousPlaceholder: void 0
      };
      return {
        state: t,
        update: function update(r) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e,
              o = n.inputElement,
              l = n.mask,
              c = n.guide,
              y = n.pipe,
              b = n.placeholderChar,
              g = void 0 === b ? h.placeholderChar : b,
              k = n.keepCharPositions,
              C = void 0 !== k && k,
              O = n.showMask,
              T = void 0 !== O && O;

          if ("undefined" == typeof r && (r = o.value), r !== t.previousConformedValue) {
            ("undefined" == typeof l ? "undefined" : s(l)) === m && void 0 !== l.pipe && void 0 !== l.mask && (y = l.pipe, l = l.mask);
            var P = void 0,
                x = void 0;

            if (l instanceof Array && (P = (0, d.convertMaskToPlaceholder)(l, g)), l !== !1) {
              var w = a(r),
                  S = o.selectionEnd,
                  _ = t.previousConformedValue,
                  M = t.previousPlaceholder,
                  j = void 0;

              if (("undefined" == typeof l ? "undefined" : s(l)) === h.strFunction) {
                if (x = l(w, {
                  currentCaretPosition: S,
                  previousConformedValue: _,
                  placeholderChar: g
                }), x === !1) return;
                var E = (0, d.processCaretTraps)(x),
                    R = E.maskWithoutCaretTraps,
                    V = E.indexes;
                x = R, j = V, P = (0, d.convertMaskToPlaceholder)(x, g);
              } else x = l;

              var N = {
                previousConformedValue: _,
                guide: c,
                placeholderChar: g,
                pipe: y,
                placeholder: P,
                currentCaretPosition: S,
                keepCharPositions: C
              },
                  A = (0, p.default)(w, x, N),
                  B = A.conformedValue,
                  I = ("undefined" == typeof y ? "undefined" : s(y)) === h.strFunction,
                  F = {};
              I && (F = y(B, u({
                rawValue: w
              }, N)), F === !1 ? F = {
                value: _,
                rejected: !0
              } : (0, d.isString)(F) && (F = {
                value: F
              }));
              var q = I ? F.value : B,
                  D = (0, f.default)({
                previousConformedValue: _,
                previousPlaceholder: M,
                conformedValue: q,
                placeholder: P,
                rawValue: w,
                currentCaretPosition: S,
                placeholderChar: g,
                indexesOfPipedChars: F.indexesOfPipedChars,
                caretTrapIndexes: j
              }),
                  L = q === P && 0 === D,
                  W = T ? P : v,
                  J = L ? W : q;
              t.previousConformedValue = J, t.previousPlaceholder = P, o.value !== J && (o.value = J, i(o, D));
            }
          }
        }
      };
    }

    function i(e, t) {
      document.activeElement === e && (b ? g(function () {
        return e.setSelectionRange(t, t, y);
      }, 0) : e.setSelectionRange(t, t, y));
    }

    function a(e) {
      if ((0, d.isString)(e)) return e;
      if ((0, d.isNumber)(e)) return String(e);
      if (void 0 === e || null === e) return v;
      throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n " + JSON.stringify(e));
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var u = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    },
        s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    };

    t.default = o;
    var l = r(4),
        f = n(l),
        c = r(3),
        p = n(c),
        d = r(2),
        h = r(1),
        v = "",
        y = "none",
        m = "object",
        b = "undefined" != typeof navigator && /Android/i.test(navigator.userAgent),
        g = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : setTimeout;
  }, function (e, t) {
    "use strict";

    function r(e) {
      return function () {
        return e;
      };
    }

    var n = function n() {};

    n.thatReturns = r, n.thatReturnsFalse = r(!1), n.thatReturnsTrue = r(!0), n.thatReturnsNull = r(null), n.thatReturnsThis = function () {
      return this;
    }, n.thatReturnsArgument = function (e) {
      return e;
    }, e.exports = n;
  }, function (e, t, r) {
    "use strict";

    function n(e, t, r, n, i, a, u, s) {
      if (o(t), !e) {
        var l;
        if (void 0 === t) l = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var f = [r, n, i, a, u, s],
              c = 0;
          l = new Error(t.replace(/%s/g, function () {
            return f[c++];
          })), l.name = "Invariant Violation";
        }
        throw l.framesToPop = 1, l;
      }
    }

    var o = function o(e) {};

    e.exports = n;
  }, function (e, t, r) {
    "use strict";

    var n = r(6),
        o = r(7),
        i = r(10);

    e.exports = function () {
      function e(e, t, r, n, a, u) {
        u !== i && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var r = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t
      };
      return r.checkPropTypes = n, r.PropTypes = r, r;
    };
  }, function (e, t, r) {
    "use strict";

    "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    }, e.exports = r(8)();
  }, function (e, t) {
    "use strict";

    var r = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    e.exports = r;
  }, function (t, r) {
    t.exports = e;
  }]);
});